import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { TeamHandle } from "resource-planner-model";
import { AppState } from "../redux/AppTypes";

export const createTeamSelector = () =>
  createSelector(
    (state: AppState) => state.teams.items,
    (_: AppState, teamId: string) => teamId,
    (items, teamId) => {
      const team = items[teamId];
      return team ? new TeamHandle(team) : undefined;
    }
  );

export default function useTeam(teamId: string): TeamHandle | undefined {
  const selector = useMemo(createTeamSelector, []);
  return useSelector((state: AppState) => selector(state, teamId));
}
